<template>
    <div class="description-item-container d-flex align-items-stretch">

        <dt class="description-label">
            <slot v-if="$slots.label" name="label"></slot>
            <template v-else>
                <label v-if="mode === 'form'" :for="labelFor">{{ label }}</label>
                <span v-else>{{ label }}</span>
            </template>
            <span v-if="required" class="text-danger ml-1">*</span>
        </dt>

        <dd :class="[mode === 'form' ? 'form-control-value' : 'description-value']">
            <slot>-</slot>
        </dd>
        <dd v-if="$slots.content" :class="[mode === 'form' ? 'form-control-value' : 'description-value']">
            <slot name="content">-</slot>
        </dd>
    </div>
</template>

<script>
export default {
    name: 'DescriptionItem',
    props: {
        label: {
            type: String,
            required: false,
            default: '',
        },
        required: {
            type: Boolean,
            default: false,
        },
        mode: {
            type: String,
            default: 'description', // 기본값은 설명 모드
            validator: (value) => ['description', 'form'].includes(value)
        },
        labelFor: {
            type: String,
            default: ''
        }
    }
};
</script>

<style lang="scss" scoped>
.description-item-container {
    //
}

label {
    margin-bottom: 0;
}
.description-label {
    display: flex;
    align-items: center;
    width: 200px;
    flex-shrink: 0;
    padding: 0.75rem 1.25rem;
    background-color: #f8f9fa;
    border-right: 1px solid #dee2e6;
    font-weight: 600;
    color: #495057;
    margin-bottom: 0;
}

.description-value {
    display: flex;
    align-items: center;
    padding: 0.75rem 1.25rem;
    min-height: 51px;
    margin-bottom: 0;
    flex-grow: 1;
    background-color: #ffffff;
    color: #212529;
}

.form-control-value {
    display: flex;
    align-items: center;
    padding: 0.5rem 0.75rem;
    min-height: 51px;
    margin-bottom: 0;
    flex-grow: 1;
    background-color: #ffffff;
}
</style>
